<template lang="pug">
#banner(v-bind:class='classes')
	.image(v-bind:style='{ backgroundImage: `url(${bannerBg})` }')
	.container.position-relative
		.row(v-if='!classes.includes("half")')
			.col-md-6
				.text
					h3.category {{ item.category }}
					h2.title {{ item.title }}
					h4.title_en(v-if='item.title_en') {{ item.title_en }}
					h4.desc {{ item.desc }}
					.list_badge(v-if='item.badges && item.badges.length > 0')
						.badge(v-for='badge in item.badges') {{ badge }}
			.col-md-6
				.ratio.ratio-16x9
					iframe(
						v-if='classes.includes("list_video")',
						v-bind:src='item.link_yt',
						frameborder='0',
						allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
						allowfullscreen=''
					)
					.media(v-else, v-bind:style='{ backgroundImage: `url(${bannerBg})` }')
		template(v-else)
			template(v-if='!classes.includes("no_title")')
				TitleStar(v-bind:classes='"banner"')
					//- Use vue slot to handle content
					//- https://v3.vuejs.org/guide/component-slots.html#slot-content
					template(v-slot:title) {{ item.title }}
</template>

<script>
import TitleStar from '@/components/TitleStar.vue';
export default {
	props: ['item', 'classes'],
	computed: {
		bannerBg: function () {
			if (this.classes.includes('external_link')) {
				return this.item.media;
			} else {
				if (!this.classes.includes('list_video')) {
					return require(`@/${this.item.media}`);
				} else {
					return '';
				}
			}
		},
	},
	components: {
		TitleStar,
	},
};
</script>

<style lang="stylus">
#banner
	position: relative
	display: flex
	align-items: center
	width: 100%
	height: 560px
	.image, .gradient
		position: absolute
		width: 100%
		height: 100%
		left: 0
		top: 0
	.image
		background-size: cover
		background-position: center center
		opacity: 0.8
		filter: opacity(0.8)
		mask: url('~@/assets/images/mask.png') no-repeat center center
		mask-size: 100vw 100%
	.text
		display: flex
		flex-direction: column
		align-items: flex-start
		color: white
		padding-top: 2.3rem
		.category, .title, .desc
			font-weight: 500
		.category
			line-height: 36px
		.title
			margin-bottom: 0
			line-height: 24px
		.title_en
			font-weight: 400
			line-height: 2
		.desc
			margin: 40px 40px 0 0
			line-height: 2rem
			text-align: justify
	.media, iframe
		border-radius: 15px
	.media
		width: 100%
		height: 100%
		background-size: cover
		background-position: center center
	&.half
		height: 352px
		align-items: flex-end
	&.item_video
		.text
			.desc
				display: -webkit-box
				-webkit-box-orient: vertical
				-webkit-line-clamp: 2
				overflow: hidden
				text-align: justify
				text-overflow: ellipsis
	@media screen and (max-width: $screen-sm-max)
		height: unset
		&.half
			height: unset
			padding: 20vh 1rem 5vh
		&.list_video
			.text
				padding-top: 6rem
			.ratio
				margin-bottom: 3rem
		&.list
			.text
				padding-top: 6rem
				.desc
					margin: 40px 0
			.ratio
				margin-bottom: 3rem
		&.item_video
			.text
				padding-top: 6rem
				.desc
					margin: 40px 0
			.ratio
				margin: 3rem 0
</style>
